module.exports = __webpack_public_path__ + "static/media/bteb_logo.1fa2678c.webp";